import { Input as OriginalInput } from 'antd';
import { withWrap } from '../../utils/hoc';
const { Group: OriginalGroup, TextArea: OriginalTextArea, Password: OriginalPassword, Search: OriginalSearch, } = OriginalInput;
const HhInput = withWrap(OriginalInput);
HhInput.Group = OriginalGroup;
HhInput.TextArea = withWrap(OriginalTextArea);
HhInput.Password = withWrap(OriginalPassword);
HhInput.Search = withWrap(OriginalSearch);
export default HhInput;
